/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './PartiuGpHero.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

const SIMULAR_URL =
  'https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=hero-banner-partiu-gp-da-inglaterra&int_campaign=simular-agora#/dados-pessoais';

function PartiuGpHero() {
  return (
    <section id="partiu-gp-hero">
      <ContainerHome24 className="hero-inner">
        <div className="hero-content">
          <img
            src="assets/partiu-gp-da-inglaterra/hero/logo-mobile.png"
            alt="Fórmula 1 e Santander — Patrocinador Oficial da Fórmula 1®"
            className="hero-logo hero-logo-mobile"
          />
          <img
            src="assets/partiu-gp-da-inglaterra/hero/logo.png"
            alt="Fórmula 1 e Santander — Patrocinador Oficial da Fórmula 1®"
            className="hero-logo hero-logo-desktop"
          />

          <h1 className="hero-titulo">
            <img
              src="assets/partiu-gp-da-inglaterra/hero/title-mobile.png"
              alt="Partiu GP da Inglaterra"
              className="hero-titulo-img hero-titulo-img-mobile"
            />
            <img
              src="assets/partiu-gp-da-inglaterra/hero/title-desktop.png"
              alt="Partiu GP da Inglaterra"
              className="hero-titulo-img hero-titulo-img-desktop"
            />
          </h1>

          <p className="hero-subtitulo">
            Financie seu veículo e concorra a uma viagem com acompanhante e tudo pago para viver a
            Fórmula 1 em Silverstone.
          </p>

          <a
            href={SIMULAR_URL}
            target="_blank"
            rel="noopener"
            className="hero-cta hero-cta-desktop"
          >
            Simular agora
          </a>
        </div>

        <div className="hero-card">
          <div className="hero-card-clip">
            <img
              src="assets/partiu-gp-da-inglaterra/hero/foto-mobile.jpg"
              alt="Carro de Fórmula 1 da Santander na pista, com torcida ao fundo."
              className="hero-card-img hero-card-img-mobile"
            />
            <img
              src="assets/partiu-gp-da-inglaterra/hero/foto-desktop.jpg"
              alt="Carro de Fórmula 1 da Santander na pista, com torcida ao fundo."
              className="hero-card-img hero-card-img-desktop"
            />

            <div className="hero-taxa">
              <img
                src="assets/partiu-gp-da-inglaterra/hero/taxa.png"
                alt="Taxas a partir de 1,29% ao mês"
                className="hero-taxa-img"
              />
              <span className="hero-taxa-legenda">Imagem meramente ilustrativa.</span>
            </div>
          </div>

          <a href={SIMULAR_URL} target="_blank" rel="noopener" className="hero-cta hero-cta-mobile">
            Simular agora
          </a>
        </div>

        <p className="hero-disclaimer">
          Sujeito à análise de crédito. Certificado de Autorização SPA/ME Nº 04.052484/2026.
        </p>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpHero;
